<template>
  <van-popup :value="visible" position="bottom" :style="{ height: '85%' }" round @update:show="val => $emit('update:visible', val)" @click-overlay="close">
    <div class="auth-container">
      <van-nav-bar :title="title" left-arrow @click-left="close" />

      <div class="auth-content-area">
        <div class="auth-tabs">
          <div :class="['auth-tab', { active: authMode === 'password' }]" @click="authMode = 'password'">
            支付密码
          </div>
          <!-- <div :class="['auth-tab', { active: authMode === 'code' }]" @click="authMode = 'code'">
            验证码
          </div> -->
        </div>

        <template v-if="authMode === 'password'">
          <p class="prompt">请输入6位支付密码</p>
          <div class="password-input-group">
            <div v-for="i in 6" :key="i" class="password-input-cell">
              {{ password[i - 1] }}
            </div>
          </div>
          <a href="#" class="forgot-password">没密码请联系部门经理，重置请在PC操作</a>
        </template>
        
        <template v-if="authMode === 'code'">
          <p class="prompt">如果没设置支付密码或没有设置邮箱，请联系部门经理设置</p>
          <div class="code-input-wrapper">
             <div class="password-input-group">
                <div v-for="i in 6" :key="i" class="password-input-cell">
                   {{ code[i - 1] }}
                </div>
            </div>
            <van-button type="default" size="small" class="send-code-btn" @click="sendCode" :disabled="isCountingDown">
                {{ countdownText }}
            </van-button>
          </div>
        </template>
      </div>

      <div class="keyboard">
        <div class="keyboard-row" v-for="(row, rowIndex) in keyboard" :key="rowIndex">
          <div class="keyboard-key" :class="{ 'empty-key': !key.action }" v-for="(key, keyIndex) in row" :key="keyIndex" @click="onKeyPress(key.action)">
             <span v-if="key.text">{{ key.text }}</span>
             <van-icon v-if="key.icon" :name="key.icon" size="24" />
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import common from '../assets/js/common'
export default {
  name: 'PaymentAuthModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
        type: String,
        default: '支付验证'
    }
  },
  data() {
    return {
      password: [],
      code: [],
      authMode: 'password', // 'password' or 'code'
      countdown: 0,
      keyboard: [
        [{text: '1', action: '1'}, {text: '2', action: '2'}, {text: '3', action: '3'}],
        [{text: '4', action: '4'}, {text: '5', action: '5'}, {text: '6', action: '6'}],
        [{text: '7', action: '7'}, {text: '8', action: '8'}, {text: '9', action: '9'}],
        [{text: '', action: null}, {text: '0', action: '0'}, {icon: 'backspace-o', action: 'delete'}]
      ]
    };
  },
  computed: {
      isCountingDown() {
          return this.countdown > 0;
      },
      countdownText() {
          return this.isCountingDown ? `${this.countdown}s` : '发送验证码';
      }
  },
  watch: {
    password(newVal) {
      if (this.authMode === 'password' && newVal.length === 6) {
        this.$emit('confirm', { password: this.password.join('') });
        this.password = [];
      }
    },
    code(newVal) {
        if(this.authMode === 'code' && newVal.length === 6) {
            this.$emit('confirm', { code: this.code.join('') });
            this.code = [];
        }
    },
    visible(newVal) {
      if (!newVal) {
        // Reset state on close
        this.password = [];
        this.code = [];
        this.authMode = 'password';
        this.countdown = 0;
        if(this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    sendCode() {
        if(this.isCountingDown) return;
        
        common.cusHttp(this, '/admin_user.php?action=send_payment_code', {}, 'post').then(res => {
            const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            if (data.errcode === 0) {
                common.mAlert(this, `验证码已发送至 ${data.data.email}`);
                this.countdown = 60;
                this.timer = setInterval(() => {
                    this.countdown--;
                    if(this.countdown <= 0) {
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            } else {
                common.mAlert(this, data.errmsg || '发送失败');
            }
        }).catch(() => {
            common.mAlert(this, '发送失败');
        });
    },
    onKeyPress(action) {
      if (!action) return;

      const targetArray = this.authMode === 'password' ? this.password : this.code;

      if (action === 'delete') {
        targetArray.pop();
      } else if (targetArray.length < 6) {
        targetArray.push(action);
      }
    }
  }
};
</script>

<style scoped>
.auth-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f7f8fa;
}
.auth-content-area {
  flex: 1;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth-tabs {
  display: inline-flex;
  margin-bottom: 32px;
  background-color: #fff;
  border-radius: 8px;
  padding: 2px;
  border: 1px solid #ebedf0;
}
.auth-tab {
  padding: 6px 20px;
  font-size: 14px;
  color: #323233;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.auth-tab.active {
  background-color: #1989fa;
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.prompt {
  font-size: 14px;
  color: #646566;
  margin-bottom: 24px;
  text-align: center;
}

.password-input-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.password-input-cell {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccd2d8;
  border-radius: 6px;
  background-color: #fff;
}

.forgot-password {
  display: block;
  margin-top: 16px;
  font-size: 14px;
  color: #1989fa;
}

.code-input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.send-code-btn {
    margin-top: 16px;
}

.keyboard {
  background-color: #f2f3f5;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
}
.keyboard-row {
  display: flex;
}
.keyboard-key {
  flex: 1;
  text-align: center;
  padding: 16px 0;
  margin: 0.5px;
  background-color: #fff;
  font-size: 22px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
}
.keyboard-key:active {
  background-color: #ebedf0;
}
.keyboard-key.empty-key {
  background-color: #f2f3f5;
  cursor: default;
}
.keyboard-key.empty-key:active {
  background-color: #f2f3f5;
}
</style>
